import { sdkVersion } from './version';
export var sdkSpecs = {
    platform: 'web',
    version: sdkVersion
};
